import { createFileRoute, redirect } from '@tanstack/react-router'
import UpgradePage from '@/spa/pages/UpgradePage'
import { canShowPurchaseUi } from '@/lib/purchase-surface'
import { routeErrorComponent } from './_shared/RouteError'

export const Route = createFileRoute('/upgrade')({
  // Native builds must not be able to reach a purchase screen at all — not by
  // deep link, not by a stale in-app link, not by the back stack. See
  // canShowPurchaseUi() for the App Review rules this implements.
  beforeLoad: () => {
    if (!canShowPurchaseUi()) throw redirect({ to: '/' })
  },
  component: UpgradePage,
  errorComponent: routeErrorComponent,
})
